import styled from 'styled-components'

export const CheckoutWrapper = styled.div`
  position: relative;
  height: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  isolation: isolate;
`

export const CheckoutBackground = styled.div`
  position: absolute;
  height: 60%;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: -1;
  pointer-events: none;
  background: black;
`

export const CheckoutLogo = styled.img`
  position: relative;
  z-index: 2;
  height: 300px;
  width: 500px;
  object-fit: contain;
  margin-top: 10%;
`

export const CheckoutContent = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
`
